import { FormikOnSubmit } from 'lib/formik.utils';
import {
  NewPasswordForm,
  NewPasswordFormModel,
} from 'pages/NewPassword/NewPasswordForm';
import React from 'react';
import { authActions } from 'state/auth/auth.actions';
import { useDispatch, useSelector } from 'react-redux';
import { setNewPassword } from 'api/AccessAPI';
import {
  authLoadingSelector,
  usernameSelector,
} from 'state/auth/auth.selectors';
import { useMutation } from 'react-query';
import { message } from 'antd';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { WrappedLanguageControl } from 'common/organisms/WrappedLanguageControl';
import { PublicContainer } from 'common/components/PublicContainer';

export const NewPasswordPage: React.FC = () => {
  const dispatch = useDispatch();
  const username = useSelector(usernameSelector);
  const isLoginBusy = useSelector(authLoadingSelector);

  const [mutate, { isLoading }] = useMutation(setNewPassword);
  const intlMessage = useFormatMessage();

  const handleSubmit: FormikOnSubmit<NewPasswordFormModel> = (formData) => {
    mutate(formData, {
      onSuccess: () => {
        message.success(intlMessage({ id: 'person.password.new.set' }));
        if (username) {
          dispatch(
            authActions.login({
              username,
              password: formData.newPassword,
            })
          );
        } else {
          dispatch(authActions.logout);
        }
      },
    });
  };

  return (
    <PublicContainer>
      <WrappedLanguageControl />
      <NewPasswordForm
        onSubmit={handleSubmit}
        loading={isLoading || isLoginBusy}
      />
    </PublicContainer>
  );
};
